import { ReactSVG } from "react-svg";
import { DivColumn, DivRow, ParagraphText } from "../../../styles/SharedStyles";
import "./WidgetIconTwo.css";

const WidgetIconTwo = ({
  iconProp,
  widthProp = "6.2rem",
  heightProp,
  widthIconProp = "100%",
  heightIconProp = "100%",
  textProp,
  textColorProp = "#2E2E2E",
  textFontWeightProp,
  textFontSizeProp,
  textFontStyleProp,
  backgroundColorProp = "#fff",
  gapProp = "0.7rem",
  cursorProp = "pointer",
  handleOnClickProp,
  buttonType = "div",
  borderProp,
  customClassNameProp,
}) => {
  const className = customClassNameProp ? `wit-1-frame-5 ${customClassNameProp}` : "wit-1-frame-5";

  return (
    <DivRow>
      <DivColumn
        className={className}
        style={{ width: widthProp, height: heightProp, background: backgroundColorProp, gap: gapProp, cursor: cursorProp, border: borderProp }}
        onClick={buttonType === "submit" ? undefined : handleOnClickProp}
        {...(buttonType === "submit" && { as: "button", type: "submit" })}
      >
        <ReactSVG
          src={iconProp}
          beforeInjection={(svg) => {
            svg.setAttribute("width", widthIconProp);
            svg.setAttribute("height", heightIconProp);
            svg.setAttribute("style", "overflow: visible;");
          }}
        />
        <ParagraphText className="wit-text" style={{ color: textColorProp, fontWeight: textFontWeightProp, fontSize: textFontSizeProp, fontStyle: textFontStyleProp }}>
          {textProp}
        </ParagraphText>
      </DivColumn>
    </DivRow>
  );
};

export default WidgetIconTwo;
